/*
 * @Author: 🐝
 * @Date: 2023-09-11 14:49:14
 * @LastEditors: Ant🐜
 * @LastEditTime: 2025-07-18 17:46:11
 * @Description: 上传接口 传参在 axios.interceptors.request.use 底层统一处理
 */
import axios from '../utils/axios'

export function uploadApi(params) {
  return axios.post('/storage/upload', params)
}
